import { render, staticRenderFns } from "./VendorOnboardingList.vue?vue&type=template&id=0fbec700"
import script from "./VendorOnboardingList.vue?vue&type=script&lang=js"
export * from "./VendorOnboardingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports